import { defineMessages } from 'react-intl';

/** The copy of the campaign setup (design outreach-v2 b, d) and of the sample pitch (d1, d2). */
export const campaignMessages = defineMessages({
  newTitle: { id: 'app.outreach.builder.title', defaultMessage: 'Pitch {song}' },
  newTitleNoSong: { id: 'app.outreach.builder.titleNoSong', defaultMessage: 'New campaign' },
  crumb: { id: 'app.outreach.builder.crumb', defaultMessage: 'New campaign' },
  // "Edit setup" of a running campaign (design outreach-v2 g1).
  editTitle: { id: 'app.outreach.builder.editTitle', defaultMessage: 'Edit the pitch of {song}' },
  crumbEdit: { id: 'app.outreach.builder.crumbEdit', defaultMessage: 'Edit setup' },
  intro: {
    id: 'app.outreach.builder.intro.v2',
    defaultMessage:
      'Set it up once. Then Plug finds new people for the song every day and pitches them from your mailbox.',
  },
  introMessage: {
    id: 'app.outreach.builder.intro.message',
    defaultMessage: 'Plug writes one pitch for each person, from your sound, the song and what they play.',
  },
  introSendFrom: {
    id: 'app.outreach.builder.intro.sendFrom',
    defaultMessage:
      'Pitches go from your own address. Curators answer a real person more often, and the replies land in your inbox.',
  },
  introStart: {
    id: 'app.outreach.builder.intro.start',
    defaultMessage: 'Check it, then start. You can change everything later, and stop at any time.',
  },
  stepOf: { id: 'app.outreach.builder.stepOf', defaultMessage: 'Step {step} of {total}' },
  next: { id: 'app.outreach.builder.next', defaultMessage: 'Next' },
  nextWho: { id: 'app.outreach.builder.next.who', defaultMessage: 'Next: who Plug contacts' },
  nextMessage: { id: 'app.outreach.builder.next.message', defaultMessage: 'Next: message' },
  nextSendFrom: { id: 'app.outreach.builder.next.sendFrom', defaultMessage: 'Next: send from' },
  nextStart: { id: 'app.outreach.builder.next.start', defaultMessage: 'Next: start' },
  back: { id: 'app.outreach.builder.back', defaultMessage: 'Back' },
  cancel: { id: 'app.outreach.builder.cancel', defaultMessage: 'Cancel' },

  stepSong: { id: 'app.outreach.builder.step.songGoal', defaultMessage: 'Song and goal' },
  stepWho: { id: 'app.outreach.builder.step.whoPlug', defaultMessage: 'Who Plug contacts' },
  stepMessage: { id: 'app.outreach.builder.step.message', defaultMessage: 'Message' },
  stepSendFrom: { id: 'app.outreach.builder.step.sendFrom', defaultMessage: 'Send from' },
  stepStart: { id: 'app.outreach.builder.step.start', defaultMessage: 'Start' },
  stepSongSub: { id: 'app.outreach.builder.step.songGoalSub', defaultMessage: 'The song and who first' },
  stepWhoSub: { id: 'app.outreach.builder.step.whoPlugSub', defaultMessage: 'Kinds and daily pitches' },
  stepMessageSub: { id: 'app.outreach.builder.step.messageSub', defaultMessage: 'The angle and your words' },
  stepSendFromSub: { id: 'app.outreach.builder.step.sendFromSub', defaultMessage: 'Your mailbox' },
  stepStartSub: { id: 'app.outreach.builder.step.startSub', defaultMessage: 'How pitches go out' },
  navSong: { id: 'app.outreach.builder.nav.song', defaultMessage: '{song} · {goal} first' },
  navWho: {
    id: 'app.outreach.builder.nav.who',
    defaultMessage: '{kinds, plural, one {# kind} other {# kinds}} · {rate} a day',
  },
  navMessageAuto: { id: 'app.outreach.builder.nav.messageAuto', defaultMessage: 'Plug picks the angle' },

  questionOf: { id: 'app.outreach.builder.question', defaultMessage: 'Question {number} of {total}' },
  songTitle: { id: 'app.outreach.builder.song.title', defaultMessage: 'Which song do you pitch?' },
  songHint: {
    id: 'app.outreach.builder.song.hint',
    defaultMessage:
      'Plug pitches one song at a time. Songs that come out soon, or came out in the last 8 weeks, get the most from it.',
  },
  songOut: { id: 'app.outreach.builder.song.out', defaultMessage: 'Out {date}' },
  songNoDate: { id: 'app.outreach.builder.song.noDate', defaultMessage: 'No release date yet' },
  songBestTime: { id: 'app.outreach.builder.song.bestTime', defaultMessage: 'Best time' },
  songOlder: { id: 'app.outreach.builder.song.older', defaultMessage: 'Older' },
  songNoneTitle: { id: 'app.outreach.builder.song.noneTitle', defaultMessage: 'Add a song first' },
  songNoneBody: {
    id: 'app.outreach.builder.song.noneBody',
    defaultMessage: 'Plug needs the audio and a release date. Curators open your song from the pitch page.',
  },
  songAdd: { id: 'app.outreach.builder.song.addMine', defaultMessage: 'Add my song' },
  songLocked: {
    id: 'app.outreach.builder.song.lockedV2',
    defaultMessage: 'Plug pitched this song already. Start a new campaign to pitch another song.',
  },
  createFailed: {
    id: 'app.outreach.builder.song.createFailed',
    defaultMessage: 'We could not make the campaign. Try again.',
  },
  changeFailed: {
    id: 'app.outreach.builder.song.changeFailed',
    defaultMessage: 'We could not change the song. Try again.',
  },
  goalTitle: { id: 'app.outreach.builder.goal.titleV2', defaultMessage: 'Who does Plug pitch first?' },
  goalHint: {
    id: 'app.outreach.builder.goal.hint',
    defaultMessage: 'Plug starts with these and adds the other kinds later. You fine-tune the kinds on the next step.',
  },
  goalPlaylists: { id: 'app.outreach.builder.goal.playlists', defaultMessage: 'Playlists' },
  goalPlaylistsSub: {
    id: 'app.outreach.builder.goal.playlistsSub',
    defaultMessage: 'Spotify, Apple Music and Deezer curators who add songs like yours.',
  },
  goalPlaylistsKicker: { id: 'app.outreach.builder.goal.playlistsKicker', defaultMessage: 'Best before release' },
  goalPress: { id: 'app.outreach.builder.goal.press', defaultMessage: 'Blogs and press' },
  goalPressSub: {
    id: 'app.outreach.builder.goal.pressSub',
    defaultMessage: 'Music blogs, magazines and newsletters that write about your sound.',
  },
  goalPressKicker: { id: 'app.outreach.builder.goal.pressKicker', defaultMessage: 'Needs 2+ weeks' },
  goalRadio: { id: 'app.outreach.builder.goal.radio', defaultMessage: 'Radio' },
  goalRadioSub: {
    id: 'app.outreach.builder.goal.radioSub',
    defaultMessage: 'Online and college radio shows that play new music.',
  },
  goalRadioKicker: { id: 'app.outreach.builder.goal.radioKicker', defaultMessage: 'Good after release' },
  goalMixed: { id: 'app.outreach.builder.goal.mixed', defaultMessage: 'A mix' },
  goalMixedSub: {
    id: 'app.outreach.builder.goal.mixedSub',
    defaultMessage: 'Plug picks the best fit of each kind every day.',
  },
  goalMixedKicker: { id: 'app.outreach.builder.goal.mixedKicker', defaultMessage: 'Most replies' },
  campaignName: { id: 'app.outreach.builder.nameV2', defaultMessage: '{song} pitch' },

  angleTitle: { id: 'app.outreach.builder.angle.title', defaultMessage: 'What the pitch leads with' },
  angleHint: {
    id: 'app.outreach.builder.angle.hint',
    defaultMessage: 'Plug picks for each person. Pick one only when you want every pitch to lead with it.',
  },
  angleAuto: { id: 'app.outreach.builder.angle.auto', defaultMessage: 'Best for each person' },
  angleAutoSub: {
    id: 'app.outreach.builder.angle.autoSub',
    defaultMessage: 'A similar artist they added, their rules, your city. Recommended.',
  },
  angleStory: { id: 'app.outreach.builder.angle.story', defaultMessage: 'The story of the song' },
  angleStorySub: { id: 'app.outreach.builder.angle.storySub', defaultMessage: 'From the story in Your sound.' },
  angleMomentum: { id: 'app.outreach.builder.angle.momentum', defaultMessage: 'Your momentum' },
  angleMomentumSub: {
    id: 'app.outreach.builder.angle.momentumSub',
    defaultMessage: 'Only the numbers you allow in Your sound.',
  },
  angleLocal: { id: 'app.outreach.builder.angle.local', defaultMessage: 'Local scene' },
  angleLocalSub: {
    id: 'app.outreach.builder.angle.localSub',
    defaultMessage: 'For playlists, blogs and radio in your countries.',
  },
  wordsTitle: { id: 'app.outreach.builder.words.title', defaultMessage: 'Your words' },
  wordsHintV2: {
    id: 'app.outreach.builder.words.hintV2',
    defaultMessage: 'Optional. Plug follows them for the tone and the details.',
  },
  wordsLabel: { id: 'app.outreach.builder.words.label', defaultMessage: 'Tell Plug anything' },
  wordsLimit: { id: 'app.outreach.builder.words.limit', defaultMessage: 'Up to 600 characters.' },
  lockedLabel: { id: 'app.outreach.builder.locked.label', defaultMessage: 'Always end with' },
  rules: {
    id: 'app.outreach.builder.rulesV2',
    defaultMessage:
      "Every pitch keeps these rules: {min} to {max} words, one link, no money, no invented facts, no emoji, the person's language.",
  },
  messageBarAuto: {
    id: 'app.outreach.builder.message.barAuto',
    defaultMessage: 'Plug picks the angle for each person',
  },
  messageBarPicked: { id: 'app.outreach.builder.message.barPicked', defaultMessage: 'Every pitch leads with: {angle}' },
  sampleTitle: { id: 'app.outreach.builder.sample.title', defaultMessage: 'Sample pitch' },
  sampleNote: {
    id: 'app.outreach.builder.sample.note',
    defaultMessage: 'Written for a sample person of each kind. It sends nothing and costs no pitch.',
  },
  sampleRun: { id: 'app.outreach.builder.sample.run', defaultMessage: 'Write a sample' },
  sampleAgain: { id: 'app.outreach.builder.sample.again', defaultMessage: 'Write again' },
  sampleTo: { id: 'app.outreach.builder.sample.to', defaultMessage: 'To: {person}' },
  sampleToAdded: { id: 'app.outreach.builder.sample.toAdded', defaultMessage: 'To: {person} who added {artist}' },
  samplePersonSpotifyPlaylist: {
    id: 'app.outreach.builder.sample.person.spotifyPlaylist',
    defaultMessage: 'a Spotify curator',
  },
  samplePersonOtherPlaylist: {
    id: 'app.outreach.builder.sample.person.otherPlaylist',
    defaultMessage: 'a playlist curator',
  },
  samplePersonPress: { id: 'app.outreach.builder.sample.person.press', defaultMessage: 'a music blog' },
  samplePersonNewsletter: {
    id: 'app.outreach.builder.sample.person.newsletter',
    defaultMessage: 'a newsletter writer',
  },
  samplePersonRadio: { id: 'app.outreach.builder.sample.person.radio', defaultMessage: 'a radio host' },
  samplePersonPodcast: { id: 'app.outreach.builder.sample.person.podcast', defaultMessage: 'a podcast host' },
  samplePersonCreator: { id: 'app.outreach.builder.sample.person.creator', defaultMessage: 'a creator' },
  sampleKindSpotifyPlaylist: {
    id: 'app.outreach.builder.sample.kind.spotifyPlaylist',
    defaultMessage: 'Spotify playlist curator',
  },
  sampleKindOtherPlaylist: {
    id: 'app.outreach.builder.sample.kind.otherPlaylist',
    defaultMessage: 'Playlist curator (Apple Music, Deezer)',
  },
  sampleKindPress: { id: 'app.outreach.builder.sample.kind.press', defaultMessage: 'Blog' },
  sampleKindNewsletter: { id: 'app.outreach.builder.sample.kind.newsletter', defaultMessage: 'Newsletter' },
  sampleKindRadio: { id: 'app.outreach.builder.sample.kind.radio', defaultMessage: 'Radio' },
  sampleKindPodcast: { id: 'app.outreach.builder.sample.kind.podcast', defaultMessage: 'Podcast' },
  sampleKindCreator: { id: 'app.outreach.builder.sample.kind.creator', defaultMessage: 'Creator' },
  sampleWriting: { id: 'app.outreach.builder.sample.writing', defaultMessage: 'Plug is writing, about 10 seconds' },
  sampleFailedTitle: {
    id: 'app.outreach.builder.sample.failed.title',
    defaultMessage: 'Plug could not write the sample this time',
  },
  sampleFailedBody: {
    id: 'app.outreach.builder.sample.failed.body',
    defaultMessage: 'Nothing is lost and this does not stop the campaign. Try again in a moment.',
  },
  sampleTryAgain: { id: 'app.outreach.builder.sample.failed.retry', defaultMessage: 'Try again' },
  sampleSongFactsTitle: {
    id: 'app.outreach.builder.sample.songFacts.title',
    defaultMessage: 'Plug needs a little more about the song',
  },
  sampleSongFactsBody: {
    id: 'app.outreach.builder.sample.songFacts.body',
    defaultMessage: 'Add a release date and one line about the song. Pitches with a story get twice the replies.',
  },
  sampleOpenSound: { id: 'app.outreach.builder.sample.songFacts.openSound', defaultMessage: 'Open Your sound' },
  sampleRateTitle: {
    id: 'app.outreach.builder.sample.rate.title',
    defaultMessage: 'You can write a new sample in {seconds} seconds',
  },
  sampleRateBody: {
    id: 'app.outreach.builder.sample.rate.body',
    defaultMessage: '10 samples a minute. The last sample stays here.',
  },
  sampleProfileTitle: {
    id: 'app.outreach.builder.sample.profile.title',
    defaultMessage: 'Plug is still reading your sound',
  },
  sampleProfileBody: {
    id: 'app.outreach.builder.sample.profile.body',
    defaultMessage: 'The sample shows when your sound profile is ready, in about a minute. You can go on.',
  },
  sampleNoneTitle: {
    id: 'app.outreach.builder.sample.none.title',
    defaultMessage: 'Plug is still looking for people like this',
  },
  sampleNoneBody: {
    id: 'app.outreach.builder.sample.none.body',
    defaultMessage: 'The sample shows when Plug found the first fits, in a few minutes.',
  },
  previewAngle: { id: 'app.outreach.builder.preview.angle', defaultMessage: 'Angle: {angle}' },
  previewFacts: { id: 'app.outreach.builder.preview.facts', defaultMessage: 'Used: {facts}' },

  summaryTitle: { id: 'app.outreach.builder.summary.title', defaultMessage: 'This campaign' },
  summarySong: { id: 'app.outreach.builder.summary.song', defaultMessage: 'Song' },
  summaryOut: { id: 'app.outreach.builder.summary.out', defaultMessage: 'Out' },
  summaryFitNow: { id: 'app.outreach.builder.summary.fitNow', defaultMessage: 'Fit now' },
  summaryKinds: { id: 'app.outreach.builder.summary.kinds', defaultMessage: 'Kinds' },
  summaryPerDay: { id: 'app.outreach.builder.summary.perDay', defaultMessage: 'Pitches a day' },
  summaryFollowUps: { id: 'app.outreach.builder.summary.followUps', defaultMessage: 'Follow-ups' },
  summaryFollowUpsValue: {
    id: 'app.outreach.builder.summary.followUpsValue',
    defaultMessage: '{on, select, true {1, free} other {None}}',
  },
  summarySendFrom: { id: 'app.outreach.builder.summary.sendFrom', defaultMessage: 'Send from' },
  summaryRunsUntil: { id: 'app.outreach.builder.summary.runsUntil', defaultMessage: 'Runs until' },
  summaryUntilStop: { id: 'app.outreach.builder.summary.untilStop', defaultMessage: 'Until you stop it' },
  summaryRateNote: {
    id: 'app.outreach.builder.summary.rateNote',
    defaultMessage: 'Your plan: {rate} new people a day. Ultra: {label} a day for each artist.',
  },
  summaryNamesNote: {
    id: 'app.outreach.builder.summary.namesNote',
    defaultMessage: 'You see each person on the campaign page after Plug pitched them. You can block anyone there.',
  },
  summaryPage: {
    id: 'app.outreach.builder.summary.page',
    defaultMessage:
      'The pitch page shows your song, cover and story. Each person gets their own link, so you see who listened.',
  },
});
